export const PdsMotion = {
  DurationLong: 600,
  DurationModerate: 400,
  DurationShort: 250,
  DurationVeryLong: 1200,
} as const;
